import { HttpHelper } from "../helper/http-helper-service";
import { constants } from "../constant/constants";
import { Contact } from "../model/crm/contact";

export default class contactApiService {
    constructor() { }

    static getContactById = (id: number, params: any) => {
        let url: string = constants.apiUrl.crmUrls.getContactById.replace(
            "{id}",
            id.toString()
        );
        return HttpHelper.getData(url, params);
    };

    static getContactByEmail = (email: string, params: any): Promise<Contact> => {
        let url: string = constants.apiUrl.crmUrls.getContactByEmail.replace(
            "{emailId}",
            email
        );
        return HttpHelper.getDataUnsafe(url, params) as Promise<Contact>;
    };

    static getContactByEmailAddress = (email: string, params: any): Promise<Contact> => {
        let url: string = constants.apiUrl.crmUrls.getContactByEmail;
        return HttpHelper.postData(url, params) as Promise<Contact>;
    };
}
